module.exports = __webpack_public_path__ + "img/PXL_20230523_142019176.a73bd8a3.jpg";